import { MantineProvider, createTheme } from '@mantine/core';
import React from 'react';

import '@mantine/core/styles.css';
import '@mantine/carousel/styles.css';
import { mantineTheme } from '../theme';
// Create Mantine theme from shared configuration
const theme = createTheme(mantineTheme);
type MantineProviderWrapperProps = {
  children: React.ReactNode;
};
function MantineProviderWrapper({ children }: MantineProviderWrapperProps) {
  return <MantineProvider theme={theme}>{children}</MantineProvider>;
}
export default MantineProviderWrapper;
export { theme };
